import React from "react";
import clsx from "clsx";
import { Skeleton } from "@mui/material";
import "./PaqueteCardSkeleton.scss";

/**
 * Componente skeleton para la card de paquete durante estados de carga
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.className=""] - Clases CSS adicionales
 * @returns {JSX.Element} Componente skeleton de card de paquete
 */
export const PaqueteCardSkeleton = ({ className = "", ...props }) => {
  return (
    <div className={clsx("paquete-card-skeleton", className)} {...props}>
      <div className="paquete-card-skeleton__header">
        <Skeleton variant="text" width="60%" height={32} animation="wave" />
        <div className="paquete-card-skeleton__divider" />
        <Skeleton variant="text" width="40%" height={20} animation="wave" />
      </div>
      <div className="paquete-card-skeleton__description">
        <Skeleton variant="text" width="100%" height={18} animation="wave" />
        <Skeleton variant="text" width="85%" height={18} animation="wave" />
      </div>
    </div>
  );
};
